<template>
  <router-view />
</template>

<script setup>
import { onMounted, ref,provide } from 'vue'
import { useStore } from "vuex";
import request from "./network/request"
import { ElMessage } from 'element-plus'

const store  = useStore()

let socket = null;

// 刷新消息（消息队列）
const flush = () => {
    request.get("/message/flush").then((res) => {
        if (res.code == 200) {
            store.commit("setUnreadCount", res.data.unreadCount)
            if(res.data.lastCount>0){
                ElMessage.success({
                message: `You have ${res.data.lastCount} new messages`,
                type: 'success',
            })
            }
        }
    })
}

const connectWebSocket = (email) => {
  socket = new WebSocket(`wss://www.gdstinfo.cn/api/log/${email}`);
  socket.onmessage = ({ data }) => {
    let res = JSON.parse(data);
    if (res.code == 200 && res.data == 'flush') {
      flush()
    }
  }
};

// 检查登录状态并建立WebSocket 连接
const checkLoginAndConnect = () => {
  const isLoggedIn = store.state.user.email;
  if (isLoggedIn) {
    flush()
    connectWebSocket(isLoggedIn);
  }
};

provide('checkLoginAndConnect', checkLoginAndConnect);

onMounted(() => {
  checkLoginAndConnect();
})

</script>

<style>
* {
  padding: 0;
  margin: 0;

}

body {
  /* 设置最小宽度和高度 */
  min-width: 1620px;
  min-height: 720px;

  /* 当内容超出时显示滚动条 */
  overflow: auto;
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
